// Vendor Components
import React from 'react';

// eslint-disable-next-line import/prefer-default-export
export const TabContext = React.createContext({
    deleteTab: undefined,
    isTabActive: undefined,
    isTabMaximized: undefined,
    toggleTabMaximized: undefined,
    selectFirstTab: undefined,
    selectTab: undefined,
});
